function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 156.5,
  cy: 156.5,
  r: 156.5,
  fill: "url(#paint0_linear)",
  fillOpacity: 0.5
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M500 99C500 136.555 469.555 167 432 167C394.445 167 364 136.555 364 99C364 61.4446 394.445 31 432 31C469.555 31 500 61.4446 500 99Z",
  fill: "#EC7373",
  fillOpacity: 0.94
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M500 99C500 136.555 469.555 167 432 167C394.445 167 364 136.555 364 99C364 61.4446 394.445 31 432 31C469.555 31 500 61.4446 500 99Z",
  fill: "#5763A2"
});

var _ref5 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 60.7986,
  y1: -28.2569,
  x2: 365.473,
  y2: 23.3371,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#E16A1E"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#CA68A4"
})));

var SvgHeaderBubbles = function SvgHeaderBubbles(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 500,
    height: 313,
    viewBox: "0 0 500 313",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _ref3, _ref4), _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHeaderBubbles, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Header-bubbles.a787fc42.svg";
export { ForwardRef as ReactComponent };